<template>
  <section class="w-full lg:px-4 px-2.5">
    <div class="flex flex-col lg:flex-col-reverse pt-2 mb-8">
      <!-- transaction types -->
      <div class="flex lg:items-start items-center my-3 lg:mt-0 lg:mb-3 w-full">
        <div class="border-b flex flex-col-reverse lg:flex-row w-full">
          <div
            class="flex items-end gap-x-2 lg:gap-x-3 font-light text-xs lg:text-sm overflow-x-auto"
          >
            <div
              class="py-2 cursor-pointer px-7 transition-all duration-150 ease-linear whitespace-nowrap"
              :class="activeClass($STATUS.PENDING)"
              @click="makeActive($STATUS.PENDING)"
              test-id="swapCategory"
            >
              Awaiting Deposit
            </div>
            <div
              class="py-2 cursor-pointer px-5"
              :class="activeClass('awaiting_business_approval')"
              @click="makeActive('awaiting_business_approval')"
              test-id="swapCategory"
            >
              Awaiting Approval
            </div>
            <div
              class="py-2 cursor-pointer px-5"
              :class="activeClass('processing')"
              @click="makeActive('processing')"
              test-id="swapCategory"
            >
              Ongoing
            </div>
            <div
              class="py-2 cursor-pointer px-5"
              :class="activeClass('completed')"
              @click="makeActive('completed')"
              test-id="swapCategory"
            >
              Completed
            </div>
          </div>
          <div
            class="flex lg:ml-auto items-center border-b lg:border-none mb-3 lg:mb-0"
          >
            <div class="lg:hidden rounded-lg border h-full">
              <transaction-category-dropdown />
            </div>
            <div class="flex gap-x-3 items-center ml-auto py-2">
              <div
                class="flex items-center gap-x-1 border border-root-3 text-root-2 px-3.5 xl:px-2.5 xl:py-1.5 lg:py-2 py-2.5 rounded-lg cursor-pointer"
                @click="showDialog('showFilterDialog')"
              >
                <filter-icon />
                <p
                  class="hidden xl:inline-block text-black-2 text-sm px-2 font-normal"
                >
                  Filter
                </p>
                <div class="hidden xl:inline-block">
                  <arrow-down-icon />
                </div>
              </div>
              <div class="flex items-center">
                <tooltip placement="top" :content="refreshToolTipContent">
                  <div class="cursor-pointer" @click="refreshTable">
                    <refresh-icon />
                  </div>
                </tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="order-1 lg:order-2 w-full border-b py-1 flex justify-end lg:justify-end items-center justify-center"
      >
        <button
          class="border pt-2 pb-2 pl-2 pr-2 rounded-lg mb-1 flex gap-x-1 gap-y-2 items-center"
          @click="openReportDialog"
        >
          <download-icon color="#5D5E68" size="h-5 w-5" class="" />
          <span class="font-light hidden md:inline text-sm"
            >Generate Report</span
          >
        </button>
      </div>
    </div>
    <div>
      <!-- dialogs -->
      <generate-report-dialog
        v-if="showReportDialog"
        :showReportDialog="showReportDialog"
        @closeReportDialog="closeReportDialog"
      />
      <!-- awaiting deposit -->
      <div v-if="isPending">
        <transactions-table
          @handleCurrentChange="handleCurrentChange"
          :tableData="pendingSwappedTransactionsTableData"
          :isLoading="isLoading"
          :page="pendingSwappedTransactionsPage"
          transactionType="pending"
          :showFilterDialog="showFilterDialog"
          @closeFilterDialog="closeDialog('showFilterDialog')"
        />
      </div>
      <!-- awaiting-business-approval -->
      <div v-if="isAwaitingApproval">
        <transactions-table
          @handleCurrentChange="handleCurrentChange"
          :tableData="awaitingSwappedTransactionsTableData"
          :isLoading="isLoading"
          :page="awaitingSwappedTransactionsPage"
          transactionType="awaiting_business_approval"
          :showFilterDialog="showFilterDialog"
          @closeFilterDialog="closeDialog('showFilterDialog')"
          @getSwappedTransactions="getSwappedTransactions"
        />
      </div>
      <!-- ongoing deposit -->
      <div v-if="isProcessing">
        <transactions-table
          @handleCurrentChange="handleCurrentChange"
          :tableData="processingSwappedTransactionsTableData"
          :isLoading="isLoading"
          :page="processingSwappedTransactionsPage"
          transactionType="processing"
          :showFilterDialog="showFilterDialog"
          @closeFilterDialog="closeDialog('showFilterDialog')"
        />
      </div>
      <!-- completed deposit -->
      <div v-if="isCompleted">
        <transactions-table
          @handleCurrentChange="handleCurrentChange"
          :tableData="completedSwappedTransactionsTableData"
          :isLoading="isLoading"
          :page="completedSwappedTransactionsPage"
          transactionType="completed"
          :showFilterDialog="showFilterDialog"
          @closeFilterDialog="closeDialog('showFilterDialog')"
        />
      </div>
    </div>
  </section>
</template>

<script>
import tenant from '@/mixins/tenant.js'
import handleFilter from '@/mixins/bridge.js'
import applyDateFilter from '@/mixins/app.js'
export default {
  mixins: [handleFilter, tenant, applyDateFilter],
  data () {
    return {
      activeCategory: 'All Transactions',
      showFilterDialog: false,
      filter: {
        currency: ''
      },
      dropdownIsVisible: false,
      search: '',
      refreshToolTipContent: 'Reset filter settings to default',
      activeTable: this.$STATUS.PENDING,
      showTableFilter: false,
      totalCounts: 4,
      isLoading: false,
      payload: {
        size: 10,
        page: 1,
        fromAsset: '',
        toAsset: '',
        fromNetwork: '',
        toNetwork: '',
        status: '',
        from: '',
        to: '',
        sort_by: '',
        sort_direction_desc: true
      },
      showReportDialog: false
    }
  },
  components: {
    TransactionsTable: () =>
      import('@/components/v2/bridge/tables/SwapTransactionsTable.vue'),
    RefreshIcon: () => import('@/assets/v2/icons/RefreshIcon.vue'),
    ArrowDownIcon: () => import('@/assets/v2/icons/ArrowDownTwo.vue'),
    DownloadIcon: () => import('@/assets/v2/icons/DownloadIcon4.vue'),
    FilterIcon: () => import('@/assets/v2/icons/FilterIcon.vue'),
    GenerateReportDialog: () =>
      import('@/components/v2/transactions/dialogs/GenerateReportDialog.vue'),
    TransactionCategoryDropdown: () =>
      import(
        '@/components/v2/transactions/dropdowns/TransactionCategoryDropdown.vue'
      )
  },
  computed: {
    isPending () {
      return this.activeTable === this.$STATUS.PENDING
    },
    isAwaitingApproval () {
      return this.activeTable === this.$STATUS.AWAITING_BUSINESS_APPROVAL
    },
    isProcessing () {
      return this.activeTable === this.$STATUS.PROCESSING
    },
    isCompleted () {
      return this.activeTable === this.$STATUS.COMPLETED
    },
    pendingSwappedTransactionsTableData () {
      return (
        this.$store?.state.bridge.pendingSwappedTransactions?.items?.swaps || []
      )
    },
    pendingSwappedTransactionsPage () {
      return this.$store?.state.bridge.pendingSwappedTransactions?.page || {}
    },
    processingSwappedTransactionsTableData () {
      return (
        this.$store.state.bridge?.processingSwappedTransactions?.items?.swaps ||
        []
      )
    },
    awaitingSwappedTransactionsTableData () {
      return (
        this.$store.state.bridge?.awaitingSwappedTransactions?.items?.swaps ||
        []
      )
    },
    processingSwappedTransactionsPage () {
      return this.$store.state.bridge.processingSwappedTransactions?.page || {}
    },
    awaitingSwappedTransactionsPage () {
      return this.$store.state.bridge.awaitingSwappedTransactions?.page || {}
    },
    completedSwappedTransactionsTableData () {
      return (
        this.$store.state.bridge.completedSwappedTransactions?.items?.swaps ||
        []
      )
    },
    completedSwappedTransactionsPage () {
      return this.$store.state.bridge.completedSwappedTransactions?.page || {}
    }
  },
  methods: {
    showDialog (dialog) {
      this[dialog] = true
    },
    closeDialog (dialog) {
      this[dialog] = false
    },
    handleCancel () {
      this.tableFormFilter.startDate = ''
      this.$emit('cancel')
      this.handleClose()
    },
    activeClass (tab) {
      return this.activeTable === tab ? 'active-class' : ''
    },
    async makeActive (swapStatus) {
      await this.getSwappedTransactions(swapStatus)
      this.activeTable = swapStatus
    },
    handleCurrentChange (payload) {
      this.payload.page = payload.val
      this.getSwappedTransactions(payload.transactionType)
    },
    handleCurrentFilterChange (val) {
      this.payload.page = val
      this.handleFilter()
    },
    refreshTable () {
      this.$store.dispatch('bridge/setFilterUse', false)
      this.getAllSwaps()
    },
    async getAllSwaps () {
      await this.getSwappedTransactions(this.$STATUS.PENDING)
      await this.getSwappedTransactions(this.$STATUS.PROCESSING)
      await this.getSwappedTransactions(this.$STATUS.AWAITING_BUSINESS_APPROVAL)
      await this.getSwappedTransactions(this.$STATUS.COMPLETED)
    },
    async getSwappedTransactions (status) {
      this.payload.status = status
      this.isLoading = true
      await this.$store
        .dispatch('bridge/getSwappedTransactions', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
    },
    openReportDialog () {
      this.showReportDialog = true
    },
    closeReportDialog () {
      this.showReportDialog = false
    }
  },
  async mounted () {
    await this.getAllSwaps()
  }
}
</script>

<style scoped>
.card {
  border-radius: 15.0613px;
}
.active-class {
  border-bottom: 1.5px solid var(--color-primary);
  font-weight: 600;
  @apply text-primary;
}
>>> .el-input--prefix .el-input__inner {
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px;
  background: var(--background-10);
}
</style>
